import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { startSpinner,finishSpinner } from "../ui/spinner";
import { generarFacturaAfiliados } from "./facturasAfiliado";

export const propuestaFacturacionTraerStart = () => ({ type: types.propuestaFacturacionTraerStart });
export const propuestaFacturacionLimpiar = () => ({ type: types.propuestaFacturacionLimpiar });
export const propuestaFacturacionModificar = (payload) => ({ type: types.propuestaFacturacionModificar, payload: payload });
export const propuestaFacturacionTraerError = (error) => ({ type: types.propuestaFacturacionTraerError, payload: error});
export const propuestaFacturacionEliminar = (payload) => ({ type: types.propuestaFacturacionEliminar, payload: payload});
export const propuestaFacturacionTraerSuccess = (payload) => {
  return {
      type: types.propuestaFacturacionTraerSuccess,
      payload: payload
  }
}
export const observacionFacturacionTraerStart = () => ({ type: types.observacionFacturacionTraerStart });
export const observacionFacturacionLimpiar = () => ({ type: types.observacionFacturacionLimpiar });
export const observacionFacturacionTraerError = (error) => ({ type: types.observacionFacturacionTraerError, payload: error});
export const observacionFacturacionTraerSuccess = (payload) => {
  return {
      type: types.observacionFacturacionTraerSuccess,
      payload: payload
  }
}

export const fetchPropuestaFacturacion = () => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(propuestaFacturacionTraerStart());
        const response = await fetchConToken(`PropuestaFacturacion/traerPropuestaFacturacion`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(propuestaFacturacionTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const agregarAfiliadoPropuesta = (idAfiliado) => {
  return async (dispatch, getState) => {
    try{
      dispatch(startSpinner());
      const response = await fetchConToken(`PropuestaFacturacion`, {idAfiliado}, 'POST');
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        const resp = await response.json();
        if (response.status !== 200) throw resp.errores;
        const { items } = getState().propuestaFacturacion;
        dispatch( propuestaFacturacionTraerSuccess([resp, ...items]) );
        dispatch( startAlerta(`El afiliado se agrego correctamente`, "success", `Exito!`) );
      }
      dispatch(finishSpinner());
    } catch (err){
      console.log( err );
      dispatch(finishSpinner());
      dispatch(startAlerta('Ocurrio un error al agregar al afiliado', "warning", `¡Error!`));
    }
  };
};

export const editarAfiliadoPropuesta = (cuil, cuota, reImputacion, periodo) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      const response = await fetchConToken(`PropuestaFacturacion`, {cuil, cuota, reImputacion, periodo}, 'PUT');
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        const resp = await response.json();
        if (response.status !== 200) throw resp.errores;

        dispatch( propuestaFacturacionModificar(resp) );
        dispatch( startAlerta(`El importe se modifico correctamente`, "success", `Exito!`) );
      }
      dispatch(finishSpinner());
    } catch (err){
      console.log( err );
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchUltimaObservacion = (idTipoComprobante) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(observacionFacturacionTraerStart());
      const response = await fetchConToken(`ObservacionesFacturacion/traerUltima/${idTipoComprobante}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const resp = await response.json();
        if (response.status !== 200) throw resp.errores;
        dispatch(observacionFacturacionTraerSuccess(resp));
      }
      //dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const modificarObservacionFacturacion = (jsonData, idTipoComprobante, descripcion, selectedAfi, callback) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(observacionFacturacionTraerStart());
      const response = await fetchConToken(`ObservacionesFacturacion`, {descripcion, idTipoComprobante}, 'POST');

      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const resp = await response.json();

        if (response.status !== 200) throw resp.errores;
        dispatch(observacionFacturacionTraerSuccess(resp));
        dispatch(generarFacturaAfiliados(jsonData, idTipoComprobante, resp.idObservacion, selectedAfi, callback));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};